import { forwardRef } from "react";

import { Input, InputProps } from "../input";

export type MonthInputProps = Omit<InputProps, "type" | "value" | "onChangeValue"> & {
  value?: string | null;
  onChangeValue?: (value: string | null) => void;
};

export const MonthInput = forwardRef<HTMLInputElement, MonthInputProps>(
  ({ value, onChangeValue, ...props }, ref) => {
    const handleChangeValue = (value: string) => {
      onChangeValue?.(value || null);
    };

    return (
      <Input ref={ref} type="month" value={value} onChangeValue={handleChangeValue} {...props} />
    );
  }
);

MonthInput.displayName = "MonthInput";
